import { http } from "@/communication";

export const moderatorMetaModule = {
  namespaced: true,
  state: {
    defaultDialogNote: null,
    modpanelStartChatText: null
  },
  actions: {
    read({ commit }) {
      commit("setWorking", true);
      return http.get("/api/v1/moderation/meta").then(({ data }) => {
        commit("setSettings", data);
        commit("setWorking", false);
      });
    }
  },
  mutations: {
    setSettings(state, { defaultDialogNote, modpanelStartChatText }) {
      state.defaultDialogNote = defaultDialogNote;
      state.modpanelStartChatText = modpanelStartChatText;
    },
    setWorking(state, working) {
      state.working = working;
    }
  },
  getters: {
    defaultDialogNote({ defaultDialogNote }) {
      return defaultDialogNote;
    },
    modpanelStartChatText({ modpanelStartChatText }) {
      return modpanelStartChatText;
    },
    working({ working }) {
      return working;
    }
  }
};
